import { Reveal } from "./Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const faqs = [
  {
    q: "Combien de temps par jour dois-je y consacrer ?",
    a: "Entre 5 et 15 minutes chaque soir. Le programme est conçu pour s’intégrer facilement à ta routine, même les jours chargés.",
  },
  {
    q: "Est-ce que NUIT CALME est un traitement médical ?",
    a: "Non. NUIT CALME est un programme de bien-être et d’hygiène du sommeil. Il ne remplace pas un avis médical. En cas de troubles du sommeil persistants, consulte un professionnel de santé.",
  },
  {
    q: "Combien de temps ai-je accès au contenu ?",
    a: "L’accès est à vie pour les formules Essentiel, Complet et Premium. Tu peux refaire les 21 nuits autant de fois que tu le souhaites.",
  },
  {
    q: "Faut-il du matériel particulier ?",
    a: "Rien de spécial. Un casque ou des écouteurs rendent les relaxations audio plus immersives, mais ce n’est pas obligatoire.",
  },
  {
    q: "À quoi sert l’abonnement à 4,90 €/mois ?",
    a: "Il est totalement optionnel. Il te donne accès chaque mois à de nouvelles histoires du soir, méditations et ambiances sonores inédites.",
  },
  {
    q: "Et si ça ne me convient pas ?",
    a: "Écris-nous dans les 14 jours et nous te remboursons intégralement, sans question. Ton sommeil ne devrait jamais être un risque.",
  },
];

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative mx-auto max-w-3xl scroll-mt-24 px-6 py-24 md:py-32 lg:px-10"
    >
      <Reveal className="mb-14 text-center">
        <p className="mb-5 text-xs font-semibold uppercase tracking-[0.3em] text-[#c9a84c]">
          Questions fréquentes
        </p>
        <h2 className="text-4xl font-light leading-tight tracking-tight sm:text-5xl">
          Tout ce qu’il faut savoir
        </h2>
      </Reveal>

      <Reveal delay={0.05}>
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-white/10"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="py-6 text-left text-lg font-light text-white hover:text-[#e8c97a] hover:no-underline"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-base leading-relaxed text-white/60">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </section>
  );
};
